import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MultiTabService implements OnDestroy {
  readonly companyChange$ = new Subject<string | null>();

  private readonly MULTI_TAB_COMPANY_CHANGE = 'mm-multi-tab-company';

  constructor() {
    this.startListening();
  }

  ngOnDestroy(): void {
    this.stopListening();
  }

  /**
   * After company change, set new companyId inside localStorage to trigger event
   * In if the future we got multiple events for multi tab handling maybe delete this function,
   * expose a single one and made switch or if statements inside of that one exposed fn
   *
   * @param companyId new companyId
   */
  onCompanyChange(companyId: string): void {
    localStorage.setItem(this.MULTI_TAB_COMPANY_CHANGE, companyId);
  }

  private startListening(): void {
    window.addEventListener('storage', this.onMultiTabStorageEvent.bind(this));
  }

  private stopListening(): void {
    window.removeEventListener('storage', this.onMultiTabStorageEvent.bind(this));
  }

  /**
   * If event is related to this service and new value of localStorage item is different from the old one send new data in matching subject
   * In case if in future we got others event in multi tab handling just create other subject and add other if/switch statements
   *
   * @param storageEvent contains key of triggered used to check if this event is related to this service
   */
  private onMultiTabStorageEvent({ key, oldValue, newValue }: StorageEvent): void {
    if (key === this.MULTI_TAB_COMPANY_CHANGE && oldValue !== newValue) {
      this.companyChange$.next(newValue);
    }
  }
}
